import React from "react";
//import HolidayMaster from "../views/leavesetup/holidaymaster/HolidayMaster";
const HolidayMaster = React.lazy(() => import('../views/leavesetup/holidaymaster/HolidayMaster'))
const CompanySetup = React.lazy(() => import('../views/Administrator/companyset/CompanySetup'))
const Generalsettings = React.lazy(() => import('../views/Administrator/general/Generalsettings'))
const ApprovalMaster = React.lazy(() => import('../views/Administrator/approvalmaster/ApprovalMaster'))
const PTConfig = React.lazy(() => import('../views/Administrator/PTConfg/PTConfig'))
const PFConfig = React.lazy(() => import('../views/Administrator/PFConfig/PFConfig'))
const ESIConfig = React.lazy(() => import('../views/Administrator/ESIConfig/ESIConfig'))
const UserGroup = React.lazy(() => import("../views/users/usergroup/UserGroup"));
const UserMaster = React.lazy(() => import("../views/users/usermaster/UserMaster"));
const CityMaster = React.lazy(() => import("../views/employee/citymaster/CityMaster"));

const UnitMaster = React.lazy(() => import("../views/employee/Unitmaster/UnitMaster"));
const BranchMaster = React.lazy(() => import("../views/employee/branchmaster/BranchMaster"));
const DepartMaster = React.lazy(() => import("../views/employee/departmaster/DepartMaster"));
const DesigMaster = React.lazy(() => import("../views/employee/desigmaster/DesigMaster"));
const QualiMaster = React.lazy(() => import("../views/employee/qualimaster/QualiMaster"));
const LocMaster = React.lazy(() => import("../views/employee/locmaster/LocMaster"));
const ShiftMaster = React.lazy(() => import("../views/employee/shiftmaster/ShiftMaster"));
const EmpCateMaster = React.lazy(() => import("../views/employee/empcatemaster/EmpCateMaster"));
const GradeMaster = React.lazy(() => import("../views/employee/grademaster/GradeMaster"));
const ContractorMaster = React.lazy(() => import("../views/employee/Contractormaster/ContractorMaster"));
const IdCardTypeMaster = React.lazy(() => import("../views/employee/idcardtypemaster/IdCardTypeMaster"));
const CurrencyMaster = React.lazy(() => import("../views/employee/currencymaster/CurrencyMaster"));
const KnownLanMaster = React.lazy(() => import("../views/employee/knownlangmaster/KnownLanMaster"));
const ProjectMaster = React.lazy(() => import("../views/employee/projectmaster/ProjectMaster"));
const LoanTypeMaster = React.lazy(() => import("../views/employee/loantypemaster/LoanTypeMaster"));
const FacilityMaster = React.lazy(() => import("../views/employee/FacilityMaster/FacilityMaster"));
const SkillCateMaster = React.lazy(() => import("../views/employee/skillcatemaster/SkillCateMaster"));
const SkillSetMaster = React.lazy(() => import("../views/employee/skillsetmaster/SkillSetMaster"));
const HobbiesMaster = React.lazy(() => import("../views/employee/hobbiesmaster/HobbiesMaster"));
const SocialMediaMaster = React.lazy(() => import("../views/employee/socialmediamaster/SocialMediaMaster"));

const FinancialYearMaster = React.lazy(() => import("../views/financial/financialyearmaster/FinancialYearMaster"));
const PayElementMaster = React.lazy(() => import("../views/financial/payelementmaster/PayElementMaster"));
const SalarySetupMaster = React.lazy(() => import("../views/financial/SalarySetupTempMaster/SalarySetupTempMaster"));
const ClaimMaster = React.lazy(() => import("../views/financial/claimmaster/ClaimMaster"));
const BankMaster = React.lazy(() => import("../views/financial/Bankmaster/BankMaster"));
const ClaimGroupMaster = React.lazy(() => import("../views/financial/claimgroupmaster/claimgroupMaster"));

const EmployeeMaster = React.lazy(() => import("../views/HR/employeemaster/EmployeeMaster"));
const EmployeeTransfer = React.lazy(() => import("../views/HR/EmployeeTransfer/EmployeeTransfer"));
const Gratuity = React.lazy(() => import("../views/HR/Gratuity/Gratuity"));
const DutyRoaster = React.lazy(() => import("../views/HR/DutyRoaster/DutyRoaster"));
const Loan = React.lazy(() => import("../views/HR/Loan/Loan"));
const HRResignation = React.lazy(() => import("../views/HR/ResignationRequest/ResignationRequest"));

const TimeAttendance = React.lazy(() => import("../views/empselfservices/timeattendance/TimeAttendance"));
const Checkin = React.lazy(() => import("../views/empselfservices/Checkin/Checkin"));
const CombOffRequestold = React.lazy(() => import("../views/empselfservices/CombOffRequestold/CombOffRequest"));
const CombOffRequest = React.lazy(() => import("../views/empselfservices/CmpOffRequest/CmpOffRequest"));
const OTRequest = React.lazy(() => import("../views/empselfservices/OTRequest/OTRequest"));
const PermissionRequest = React.lazy(() => import("../views/empselfservices/PermissionRequest/PermissionRequest"));
const OnDutyRequest = React.lazy(() => import("../views/empselfservices/OnDutyRequest/OnDutyRequest"));
const Advance = React.lazy(() => import("../views/empselfservices/advance/Advance"));
const LeaveRequest = React.lazy(() => import("../views/empselfservices/leavereq/LeaveRequest"));
const Reimbursment = React.lazy(() => import("../views/empselfservices/reimbursment/Reimbursment"));
const TravelExpense = React.lazy(() => import("../views/empselfservices/TravelExpense/TravelExpense"));
const OtherExpense = React.lazy(() => import("../views/empselfservices/OtherExpense/OtherExpense"));
const TourApproval = React.lazy(() => import("../views/empselfservices/TourApproval/TourApproval"));
const TourReport = React.lazy(() => import("../views/empselfservices/TourReport/TourReport"));

const EMPPayslip = React.lazy(() => import("../views/empselfservices/payslip/Payslip"));
const ResignationRequest = React.lazy(() => import("../views/empselfservices/ResignationRequest/ResignationRequest"));

const LeaveRule = React.lazy(() => import("../views/leavesetup/LeaveRule/LeaveRule"));
const OpenLeaveBalance = React.lazy(() => import("../views/leavesetup/openleavebal/OpenLeaveBalance"));
const LeaveTypeMaster = React.lazy(() => import("../views/leavesetup/leavesetupmaster/LeaveTypeMaster"));
const WeekOffMaster = React.lazy(() => import("../views/leavesetup/weekoff/WeekOffMaster")); 

const  AttendanceUpload =React.lazy(()=>import("../views/Payroll/AttendanceUpload/AttendanceUpload"));
const AdocPayment =React.lazy(()=>import("../views/Payroll/adocpayment/AdocPayment"));
const LOPEntry =React.lazy(()=>import("../views/Payroll/Lopentry/LOPEntry"));
const PayrollProcess=React.lazy(()=>import("../views/Payroll/payrollprocess/PayrollProcess"));
const PayrollProcessLock=React.lazy(()=>import("../views/Payroll/payrollprocesslock/PayrollProcesslock"));
const DailyWagesUpload=React.lazy(()=>import("../views/Payroll/DailyWagesUpload/DailyWagesUpload"));
const PaySlip=React.lazy(()=>import("../views/Payroll/payslip/Payslip"));
const PayRegister=React.lazy(()=>import("../views/Payroll/PayRegister/PayRegister"));
const MusterRoll=React.lazy(()=>import("../views/Payroll/Muster Roll/MusterRoll"));
const AttendanceBettaUpload =React.lazy(()=>import("../views/Payroll/AttendanceBettaUpload/AttendanceBettaUpload"));
// const Dashboard = React.lazy(() => import('./views/dashboard/Dashboard'))

const ApprovalList = React.lazy(() => import("../views/Notifications/Approval/Approval"));

const MonthlyAttendance = React.lazy(() => import("../views/Reports/MonthlyAttendance/MonthlyAttendance"));
const SmartReport = React.lazy(() => import("../views/Reports/SmartReport/SmartReport"));
const SmartReportExecute = React.lazy(() => import("../views/Reports/SmartReportExecute/SmartReportExecute"));

const SAPB1ServerConfig = React.lazy(() => import("../views/SAP B1/SetUp/Serverconfig/Serverconfig"));
const SAPB1GLConfig = React.lazy(() => import("../views/SAP B1/SetUp/GL Config/GLConfig"));

const SAPB1ProjectMaster = React.lazy(() => import("../views/SAP B1/Pull/ProjectMaster/ProjectMaster"));
const SAPB1EmployeeCostCenter = React.lazy(() => import("../views/SAP B1/Posting/EmployeeCostCenter/EmployeeCostCenter"));
const SAPB1LoanAdvance = React.lazy(() => import("../views/SAP B1/Posting/Loan&Advance/Loan&Advance"));
const SAPB1Payroll = React.lazy(() => import("../views/SAP B1/Posting/Payroll/Payroll"));

const Paid = React.lazy(() => import("../views/Paid or Verify/Paid"));
const Verify = React.lazy(() => import("../views/Paid or Verify/Verified"));

const PaidTourApp = React.lazy(() => import("../views/Paid Tour Approval/Paid"));

const BookTourApp = React.lazy(() => import("../views/Book Tour Approval/Paid"));

const routes = [
  { path: "/", exact: true, name: "Home" },
  { path: '/Administrator/CompanySetup', name: 'Company Setup', element: CompanySetup },
  { path: '/SystemInitialization/GeneralSettings', name: 'General Settings', element: Generalsettings },
  { path: '/SystemInitialization/approvalmaster', name: 'Approval Master', element: ApprovalMaster },

  { path: "/users/usergroup", name: "User Group", element: UserGroup },
  { path: "/users/usermaster", name: "User Master", element: UserMaster },

  { path: "/SystemInitialization/unitmaster", name: "Unit Master", element: UnitMaster },
  { path: "/SystemInitialization/BranchMaster", name: "Branch Master", element: BranchMaster, },
  { path: "/SystemInitialization/PTConfig", name: "PT Configuration", element: PTConfig, },
  { path: "/SystemInitialization/PFConfig", name: "PF Configuration", element: PFConfig, },
  { path: "/SystemInitialization/ESIConfig", name: "ESI Configuration", element: ESIConfig, },
  { path: "/SystemInitialization/CityMaster", name: "City Master", element: CityMaster, },
  { path: "/EmployeeSetup/contractormaster", name: "Contractor Master", element: ContractorMaster, },
  { path: "/EmployeeSetup/departmaster", name: "Department Master", element: DepartMaster, },
  { path: "/EmployeeSetup/desigmaster", name: "Designation Master", element: DesigMaster, },
  { path: "/EmployeeSetup/qualimaster", name: "Qualification Master", element: QualiMaster, },
  { path: "/EmployeeSetup/locmaster", name: "Location Master", element: LocMaster },
  { path: "/EmployeeSetup/shiftmaster", name: "Shift Master", element: ShiftMaster },
  { path: "/EmployeeSetup/empcatemaster", name: "Employee Category Master", element: EmpCateMaster, },
  { path: "/EmployeeSetup/grademaster", name: "Grade Master", element: GradeMaster },
  { path: "/EmployeeSetup/idcardtypemaster", name: "IdCardType Master", element: IdCardTypeMaster, },
  { path: "/EmployeeSetup/currencymaster", name: "Currency Master", element: CurrencyMaster, },
  { path: "/EmployeeSetup/knownlangmaster", name: "Known Language Master", element: KnownLanMaster, },
  { path: "/EmployeeSetup/projectmaster", name: "Project Master", element: ProjectMaster, },
  { path: "/EmployeeSetup/loantypemaster", name: "LoanType Master", element: LoanTypeMaster, },
  { path: "/EmployeeSetup/facilitymaster", name: "Facility Master", element: FacilityMaster, },
  { path: "/EmployeeSetup/skillcatemaster", name: "Skill Category Master", element: SkillCateMaster, },
  { path: "/EmployeeSetup/skillsetmaster", name: "Skill Set Master", element: SkillSetMaster, },
  { path: "/EmployeeSetup/hobbiesmaster", name: "Hobbies Master", element: HobbiesMaster, },
  { path: "/EmployeeSetup/socialmediamaster", name: "Social Media Master", element: SocialMediaMaster, },

  { path: "/FinancialSetup/financialyearmaster", name: "Financial Year Master", element: FinancialYearMaster, },
  { path: "/FinancialSetup/payelementmaster", name: " Pay Element Master", element: PayElementMaster, },
  { path: "/FinancialSetup/salarysetupmaster", name: " Salary Setup Master", element: SalarySetupMaster, },
  { path: "/FinancialSetup/claimmaster", name: " Claim Master", element: ClaimMaster, },
  { path: "/FinancialSetup/claimGroupmaster", name: " Claim Group Master", element: ClaimGroupMaster, },
  { path: "/FinancialSetup/Bankmaster", name: " Bank Master", element: BankMaster, },
  
  { path: "/HR/employeemaster", name: "Employee Master", element: EmployeeMaster, },
  { path: "/HR/EmployeeTransfer", name: "Employee Transfer", element: EmployeeTransfer, },
  { path: "/HR/Gratuity", name: "Gratuity", element: Gratuity, },
  { path: "/HR/DutyRoaster", name: "Duty Roaster", element: DutyRoaster, },
  { path: "/HR/Loan", name: "Loan & Advance", element: Loan, },
  { path: "/HR/Resignation", name: "Resignation", element: HRResignation, },

  { path: "/EmployeeSelfServices/timeattendance", name: "Time Attendance Entry", element: TimeAttendance, },
  { path: "/EmployeeSelfService/Checkin", name: "Checkin / Checkout",element:Checkin,},
  { path: "/EmployeeSelfService/CompensatoryOff", name: "Compensatory Off Request",element:CombOffRequest,},
  { path: "/EmployeeSelfService/CompensatoryOffold", name: "Compensatory Off Request old",element:CombOffRequestold,},
  { path: "/EmployeeSelfService/advance", name:"Advance Reimbursment Request",element:Advance},
  { path: "/EmployeeSelfService/leavereq", name:"Leave Request",element:LeaveRequest},
  { path: "/EmployeeSelfService/reimbursment", name:"Reimbursment Request",element:Reimbursment},
  { path: "/EmployeeSelfService/TravelExpense", name:"Travel Expense Request",element:TravelExpense},
  { path: "/EmployeeSelfService/OtherExpense", name:"Other Expense Request",element:OtherExpense},
  { path: "/EmployeeSelfService/TourApproval", name:"Tour Approval Form",element:TourApproval},
  { path: "/EmployeeSelfService/TourReport", name:"Tour Report",element:TourReport},
  { path: "/EmployeeSelfService/OTRequest", name:"OT Request",element:OTRequest},
  { path: "/EmployeeSelfService/PermissionRequest", name:"Permission Request",element:PermissionRequest},
  { path: "/EmployeeSelfService/OnDutyRequest", name:"OnDuty Request",element:OnDutyRequest},
  { path: "/EmployeeSelfService/PaySlip", name:"PaySlip",element:EMPPayslip},
  { path: "/EmployeeSelfService/ResignationRequest", name:"Resignation Request",element:ResignationRequest},

  { path: "/LeaveSetup/LeaveRule", name: "Leave Rule", element: LeaveRule, },
  { path: "/LeaveSetup/openleavebal", name: "Open Leave Balance", element: OpenLeaveBalance, },
  { path: "/LeaveSetup/leavesetupmaster", name: "Leave Type Master", element: LeaveTypeMaster, },
  { path: "/LeaveSetup/holidaymaster", name: "Holiday Master", element: HolidayMaster, },
  { path: "/LeaveSetup/weekoff", name: "Week Off Master", element: WeekOffMaster, },

  { path: "/Payroll/AttendanceUpload", name: "Attendance Upload", element: AttendanceUpload, },
  { path: "/Payroll/DailyWagesUpload", name: "Daily Wages Upload", element: DailyWagesUpload, },
  { path: "/Payroll/adocpayment", name: "Adoc Payment", element: AdocPayment, },
  { path: "/Payroll/Lopentry", name: "LOP Entry", element: LOPEntry, },
  { path: "/Payroll/payrollprocess", name: "Payroll Process", element: PayrollProcess, },
  { path: "/Payroll/payrollprocesslock", name: "Payroll Process Lock", element: PayrollProcessLock, },
  { path: "/Payroll/PaySlip", name: "PaySlip", element: PaySlip, },
  { path: "/Payroll/PayRegister", name: "Pay Register", element: PayRegister, },
  { path: "/Payroll/MusterRoll", name: "Muster Roll", element: MusterRoll, },
  { path: "/Payroll/AttendanceBettaUpload", name: "Attendance Betta Upload", element: AttendanceBettaUpload, },

  { path: "/ApprovalList", name: "Approval List", element: ApprovalList, },

  { path: "/Reports/MonthlyAttendance", name: "Monthly Attendance", element: MonthlyAttendance, },
  { path: "/Reports/SmartReport", name: "Smart Report", element: SmartReport, },
  { path: "/Reports/SmartReportExecute", name: "Smart Report", element: SmartReportExecute, },

  { path: "/SAPB1/Setup/ServerConfig", name: "Server Config", element: SAPB1ServerConfig, },
  { path: "/SAPB1/Setup/GLConfig", name: "GL Config", element: SAPB1GLConfig, },
  { path: "/SAPB1/Pull/ProjectMaster", name: "Project Master", element: SAPB1ProjectMaster, },
  { path: "/SAPB1/Posting/EmployeeCostCenter", name: "Employee Cost Center", element: SAPB1EmployeeCostCenter, },
  { path: "/SAPB1/Posting/LoanAdvance", name: "Loan & Advance", element: SAPB1LoanAdvance, },
  { path: "/SAPB1/Posting/Payroll", name: "Payroll", element: SAPB1Payroll, },
  { path: "/Paid", name: "Paid", element: Paid, },
  { path: "/Verify", name: "Verify", element: Verify, },
  { path: "/PaidTourApp", name: "Paid Tour Approval", element: PaidTourApp, },
  { path: "/BookTourApp", name: "Book Tour Approval", element: BookTourApp, },
];

export default routes;
